// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2Lh27","inputWrap":"Table_inputWrap__38IXI","col":"Table_col__2Xkdd","bmiTooltip":"Table_bmiTooltip__3Tszm"};